import React from 'react'
import CommonFetch from '../../requests/commonFetch'

const requestTFACode = (props = {}) => {
    CommonFetch({
        path: 'ui/auth/post_request2facode',
        method: 'POST',
    })
        .then(data => {
            if (data.success && props.success) {
                props.success()
            }
        })
        .catch(error => {
            throw Error(error.message).stack
        })
}

export default requestTFACode
